var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.root,style:({
    '--grid-columns': _vm.currentOptions.columns,
    '--row-gap': _vm.currentOptions['row-gap'],
    '--column-gap': _vm.currentOptions['column-gap'],
    '--border-bottom': _vm.currentOptions['border-bottom-width'] || 0,
  })},_vm._l((_vm.data),function(item,key){return _c('dl',{key:key,class:_vm.css.list},[_c('dt',{class:_vm.css.title,domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('dd',{class:_vm.css.description,domProps:{"innerHTML":_vm._s(item.description)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }